import React from 'react'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  width: {
    minWidth: '100%'
  }
})

export interface DatePickerProps {
  label: string;
  value: Date | null;  
  onChange: (date: Date | null) => void;
  disabled?: boolean;
}

export const DatePicker: React.FC<DatePickerProps> = function (props) {
  const { label, value, onChange, disabled = false } = props
  const styles = useStyles()

  return (
    <KeyboardDatePicker
      disabled={disabled}
      disableToolbar
      variant="inline"
      format="dd/MM/yyyy"
      margin="normal"
      label={label}
      value={value}
      onChange={onChange}
      className={styles.width}
    />
  )
}
